'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        axisDefaultsBackground: {
            type: String,
            kComposite: 'axisDefaults.background'
        },
        axisDefaultsColor: {
            type: String,
            kComposite: 'axisDefaults.color'
        },
        axisDefaultsCrosshairColor: {
            type: String,
            kComposite: 'axisDefaults.crosshair.color'
        },
        axisDefaultsCrosshairDashType: {
            type: String,
            kComposite: 'axisDefaults.crosshair.dashType'
        },
        axisDefaultsCrosshairOpacity: {
            type: Number,
            kComposite: 'axisDefaults.crosshair.opacity'
        },
        axisDefaultsCrosshairTooltipBackground: {
            type: String,
            kComposite: 'axisDefaults.crosshair.tooltip.background'
        },
        axisDefaultsCrosshairTooltipBorderColor: {
            type: String,
            kComposite: 'axisDefaults.crosshair.tooltip.border.color'
        },
        axisDefaultsCrosshairTooltipBorderDashType: {
            type: String,
            kComposite: 'axisDefaults.crosshair.tooltip.border.dashType'
        },
        axisDefaultsCrosshairTooltipBorderWidth: {
            type: Number,
            kComposite: 'axisDefaults.crosshair.tooltip.border.width'
        },
        axisDefaultsCrosshairTooltipColor: {
            type: String,
            kComposite: 'axisDefaults.crosshair.tooltip.color'
        },
        axisDefaultsCrosshairTooltipFont: {
            type: String,
            kComposite: 'axisDefaults.crosshair.tooltip.font'
        },
        axisDefaultsCrosshairTooltipFormat: {
            type: String,
            kComposite: 'axisDefaults.crosshair.tooltip.format'
        },
        axisDefaultsCrosshairTooltipPadding: {
            type: Number,
            kComposite: 'axisDefaults.crosshair.tooltip.padding'
        },
        axisDefaultsCrosshairTooltipPaddingBottom: {
            type: Number,
            kComposite: 'axisDefaults.crosshair.tooltip.padding.bottom'
        },
        axisDefaultsCrosshairTooltipPaddingLeft: {
            type: Number,
            kComposite: 'axisDefaults.crosshair.tooltip.padding.left'
        },
        axisDefaultsCrosshairTooltipPaddingRight: {
            type: Number,
            kComposite: 'axisDefaults.crosshair.tooltip.padding.right'
        },
        axisDefaultsCrosshairTooltipPaddingTop: {
            type: Number,
            kComposite: 'axisDefaults.crosshair.tooltip.padding.top'
        },
        axisDefaultsCrosshairTooltipTemplate: {
            type: String | Function,
            kComposite: 'axisDefaults.crosshair.tooltip.template'
        },
        axisDefaultsCrosshairTooltipVisible: {
            type: Boolean,
            kComposite: 'axisDefaults.crosshair.tooltip.visible'
        },
        axisDefaultsCrosshairVisible: {
            type: Boolean,
            kComposite: 'axisDefaults.crosshair.visible'
        },
        axisDefaultsCrosshairWidth: {
            type: Number,
            kComposite: 'axisDefaults.crosshair.width'
        },
        axisDefaultsLabelsFont: {
            type: String,
            kComposite: 'axisDefaults.labels.font'
        },
        axisDefaultsLabelsFormat: {
            type: String,
            kComposite: 'axisDefaults.labels.format'
        },
        axisDefaultsLabelsMargin: {
            type: Number,
            kComposite: 'axisDefaults.labels.margin'
        },
        axisDefaultsLabelsMarginBottom: {
            type: Number,
            kComposite: 'axisDefaults.labels.margin.bottom'
        },
        axisDefaultsLabelsMarginLeft: {
            type: Number,
            kComposite: 'axisDefaults.labels.margin.left'
        },
        axisDefaultsLabelsMarginRight: {
            type: Number,
            kComposite: 'axisDefaults.labels.margin.right'
        },
        axisDefaultsLabelsMarginTop: {
            type: Number,
            kComposite: 'axisDefaults.labels.margin.top'
        },
        axisDefaultsLabelsMirror: {
            type: Boolean,
            kComposite: 'axisDefaults.labels.mirror'
        },
        axisDefaultsLabelsPadding: {
            type: Number,
            kComposite: 'axisDefaults.labels.padding'
        },
        axisDefaultsLabelsPaddingBottom: {
            type: Number,
            kComposite: 'axisDefaults.labels.padding.bottom'
        },
        axisDefaultsLabelsPaddingLeft: {
            type: Number,
            kComposite: 'axisDefaults.labels.padding.left'
        },
        axisDefaultsLabelsPaddingRight: {
            type: Number,
            kComposite: 'axisDefaults.labels.padding.right'
        },
        axisDefaultsLabelsPaddingTop: {
            type: Number,
            kComposite: 'axisDefaults.labels.padding.top'
        },
        axisDefaultsLabelsRotation: {
            type: Number | String,
            kComposite: 'axisDefaults.labels.rotation'
        },
        axisDefaultsLabelsRotationAlign: {
            type: String,
            kComposite: 'axisDefaults.labels.rotation.align'
        },
        axisDefaultsLabelsRotationAngle: {
            type: Number | String,
            kComposite: 'axisDefaults.labels.rotation.angle'
        },
        axisDefaultsLabelsSkip: {
            type: Number,
            kComposite: 'axisDefaults.labels.skip'
        },
        axisDefaultsLabelsStep: {
            type: Number,
            kComposite: 'axisDefaults.labels.step'
        },
        axisDefaultsLabelsTemplate: {
            type: String | Function,
            kComposite: 'axisDefaults.labels.template'
        },
        axisDefaultsLabelsVisible: {
            type: Boolean,
            kComposite: 'axisDefaults.labels.visible'
        },
        axisDefaultsLabelsVisual: {
            type: Function,
            kComposite: 'axisDefaults.labels.visual'
        },
        axisDefaultsLineColor: {
            type: String,
            kComposite: 'axisDefaults.line.color'
        },
        axisDefaultsLineDashType: {
            type: String,
            kComposite: 'axisDefaults.line.dashType'
        },
        axisDefaultsLineVisible: {
            type: Boolean,
            kComposite: 'axisDefaults.line.visible'
        },
        axisDefaultsLineWidth: {
            type: Number,
            kComposite: 'axisDefaults.line.width'
        },
        axisDefaultsMajorGridLinesColor: {
            type: String,
            kComposite: 'axisDefaults.majorGridLines.color'
        },
        axisDefaultsMajorGridLinesDashType: {
            type: String,
            kComposite: 'axisDefaults.majorGridLines.dashType'
        },
        axisDefaultsMajorGridLinesVisible: {
            type: Boolean,
            kComposite: 'axisDefaults.majorGridLines.visible'
        },
        axisDefaultsMajorGridLinesWidth: {
            type: Number,
            kComposite: 'axisDefaults.majorGridLines.width'
        },
        axisDefaultsMajorGridLinesStep: {
            type: Number,
            kComposite: 'axisDefaults.majorGridLines.step'
        },
        axisDefaultsMajorGridLinesSkip: {
            type: Number,
            kComposite: 'axisDefaults.majorGridLines.skip'
        },
        axisDefaultsMajorTicksColor: {
            type: String,
            kComposite: 'axisDefaults.majorTicks.color'
        },
        axisDefaultsMajorTicksSize: {
            type: Number,
            kComposite: 'axisDefaults.majorTicks.size'
        },
        axisDefaultsMajorTicksVisible: {
            type: Boolean,
            kComposite: 'axisDefaults.majorTicks.visible'
        },
        axisDefaultsMajorTicksWidth: {
            type: Number,
            kComposite: 'axisDefaults.majorTicks.width'
        },
        axisDefaultsMajorTicksStep: {
            type: Number,
            kComposite: 'axisDefaults.majorTicks.step'
        },
        axisDefaultsMajorTicksSkip: {
            type: Number,
            kComposite: 'axisDefaults.majorTicks.skip'
        },
        axisDefaultsMinorGridLinesColor: {
            type: String,
            kComposite: 'axisDefaults.minorGridLines.color'
        },
        axisDefaultsMinorGridLinesDashType: {
            type: String,
            kComposite: 'axisDefaults.minorGridLines.dashType'
        },
        axisDefaultsMinorGridLinesVisible: {
            type: Boolean,
            kComposite: 'axisDefaults.minorGridLines.visible'
        },
        axisDefaultsMinorGridLinesWidth: {
            type: Number,
            kComposite: 'axisDefaults.minorGridLines.width'
        },
        axisDefaultsMinorGridLinesStep: {
            type: Number,
            kComposite: 'axisDefaults.minorGridLines.step'
        },
        axisDefaultsMinorGridLinesSkip: {
            type: Number,
            kComposite: 'axisDefaults.minorGridLines.skip'
        },
        axisDefaultsMinorTicksColor: {
            type: String,
            kComposite: 'axisDefaults.minorTicks.color'
        },
        axisDefaultsMinorTicksSize: {
            type: Number,
            kComposite: 'axisDefaults.minorTicks.size'
        },
        axisDefaultsMinorTicksVisible: {
            type: Boolean,
            kComposite: 'axisDefaults.minorTicks.visible'
        },
        axisDefaultsMinorTicksWidth: {
            type: Number,
            kComposite: 'axisDefaults.minorTicks.width'
        },
        axisDefaultsMinorTicksStep: {
            type: Number,
            kComposite: 'axisDefaults.minorTicks.step'
        },
        axisDefaultsMinorTicksSkip: {
            type: Number,
            kComposite: 'axisDefaults.minorTicks.skip'
        },
        axisDefaultsNarrowRange: {
            type: Boolean,
            kComposite: 'axisDefaults.narrowRange'
        },
        axisDefaultsPane: {
            type: String,
            kComposite: 'axisDefaults.pane'
        },
        axisDefaultsPlotBands: {
            type: Array,
            kComposite: 'axisDefaults.plotBands'
        }, axisDefaultsReverse: {
            type: Boolean,
            kComposite: 'axisDefaults.reverse'
        },
        axisDefaultsStartAngle: {
            type: Number,
            kComposite: 'axisDefaults.startAngle'
        },
        axisDefaultsTitleBackground: {
            type: String,
            kComposite: 'axisDefaults.title.background'
        },
        axisDefaultsTitleBorderColor: {
            type: String,
            kComposite: 'axisDefaults.title.border.color'
        },
        axisDefaultsTitleBorderDashType: {
            type: String,
            kComposite: 'axisDefaults.title.border.dashType'
        },
        axisDefaultsTitleBorderWidth: {
            type: Number,
            kComposite: 'axisDefaults.title.border.width'
        },
        axisDefaultsTitleColor: {
            type: String,
            kComposite: 'axisDefaults.title.color'
        },
        axisDefaultsTitleFont: {
            type: String,
            kComposite: 'axisDefaults.title.font'
        },
        axisDefaultsTitleMargin: {
            type: Number,
            kComposite: 'axisDefaults.title.margin'
        },
        axisDefaultsTitleMarginBottom: {
            type: Number,
            kComposite: 'axisDefaults.title.margin.bottom'
        },
        axisDefaultsTitleMarginLeft: {
            type: Number,
            kComposite: 'axisDefaults.title.margin.left'
        },
        axisDefaultsTitleMarginRight: {
            type: Number,
            kComposite: 'axisDefaults.title.margin.right'
        },
        axisDefaultsTitleMarginTop: {
            type: Number,
            kComposite: 'axisDefaults.title.margin.top'
        },
        axisDefaultsTitlePadding: {
            type: Number,
            kComposite: 'axisDefaults.title.padding'
        },
        axisDefaultsTitlePaddingBottom: {
            type: Number,
            kComposite: 'axisDefaults.title.padding.bottom'
        },
        axisDefaultsTitlePaddingLeft: {
            type: Number,
            kComposite: 'axisDefaults.title.padding.left'
        },
        axisDefaultsTitlePaddingRight: {
            type: Number,
            kComposite: 'axisDefaults.title.padding.right'
        },
        axisDefaultsTitlePaddingTop: {
            type: Number,
            kComposite: 'axisDefaults.title.padding.top'
        },
        axisDefaultsTitlePosition: {
            type: String,
            kComposite: 'axisDefaults.title.position'
        },
        axisDefaultsTitleRotation: {
            type: Number,
            kComposite: 'axisDefaults.title.rotation'
        },
        axisDefaultsTitleText: {
            type: String,
            kComposite: 'axisDefaults.title.text'
        },
        axisDefaultsTitleVisible: {
            type: Boolean,
            kComposite: 'axisDefaults.title.visible'
        },
        axisDefaultsTitleVisual: {
            type: Function,
            kComposite: 'axisDefaults.title.visual'
        },
        axisDefaultsVisible: {
            type: Boolean,
            kComposite: 'axisDefaults.visible'
        }
    }
};